import { ResultProps } from 'antd';
import { Component, ErrorInfo, ReactNode } from 'react';
import ErrorFallback from './ErrorFallback';

export interface ErrorBoundaryState {
    error: Error | null;
}

export type GrispiActionCallback = (...args: any) => Promise<void | any> | void;

export interface ErrorFallbackProps {
    actionButtonText?: string;
    antdProps?: ResultProps;
    error: Error;
    fixedHeight?: boolean;
    onActionButtonClick?: GrispiActionCallback;
}

export interface ErrorBoundaryProps {
    children?: ReactNode;
    onError?: (error: Error, info: ErrorInfo) => void;
}

const initialState = { error: null };

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = initialState;
    }
    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error({ error, info });
        this.props.onError?.(error, info);
    }

    render() {
        const { error } = this.state;

        if (error) return <ErrorFallback error={error} />;

        return this.props.children;
    }
}

export default ErrorBoundary;
